import React, { Component } from 'react';
import { connect } from 'react-redux'

import DataGrid, {
    Column,
    Scrolling,
    Sorting,
    Paging,
    Pager,
    LoadPanel,Button
    
} from 'devextreme-react/data-grid';
import '../WindowPopUp/Selectqr.css';
import {Button1} from 'devextreme-react/button';



import FetchData from '../../components/Utils/FetchData'

class SelectQRCodeProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //folderid: "DB43882D-E3A8-4885-8E5A-7F446292BA5B",
            folderid: this.props.folderIdState,
            qrprofiles: [],
            objectid: this.props.currentObjectIdState[0],
            userid: this.props.usedataState,
            rodeid: this.props.roledataId,
            taskid: this.props.taskIdState
        };

        this.populateData = this.populateData.bind(this);


        this.onClickButton = this.onClickButton.bind(this);

    }

    onClickButton(e) {
        var id = 'thanasis mourselas'
        var url = window.location.href
        const editedURL = url.slice(0, -8)
        alert(editedURL)
        console.log(editedURL)
        //window.open(editedURL + 'GenerateQR', "Popup", "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=880, height=600, top=100 , left = 500")
        //window.open("http://localhost:5001/GenerateQR", "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=880, height=600, top=100 , left = 500")
        window.open("http://localhost:5001/GenerateQRCode?id="+id, "second", "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=880, height=600, top=100 , left = 500")
        //window.open("http://localhost:5001/GenerateQR");

    }
    populateData() {

        console.log('populateData')

        //FetchData('/api/QRCode/GetQRCodeProfilesByFolderID/' + this.state.folderid + '')
        //    .then((data) => {

        //        console.log(data)
        //        this.setState({
        //            qrprofiles: data.data,

        //        })
        //        console.log('this.state.qrprofiles')

        //        console.log(this.state.qrprofiles)

        //    }).catch(function (error) {
        //        if (error == "TOKEN_REFRESH_EXCEPTION") {
        //            alert('Your login session has expired, please log in again.')
        //            window.location.href = '/';
        //        }
        //    });

    }


    componentDidMount() {
        console.log('Component Did MOUNT!')  // 1
        this.populateData()

    }

    componentDidUpdate(prevProps, prevState) {

        console.log('Component Did UPDATE!')  //4-- 2
        console.log(prevState.hello)
        console.log(this.state.hello)

    }
    componentWillUnmount() {
        console.log('Component Will UNMOUNT!')
    }
    render() {
        return (
            <div>
                <div style={{ width: '100%', height: '40px', borderBottom: '1px solid #d2d6de', position: 'fixed', backgroundColor: '#c1ebfb' }}>
                    <span style={{ width: '40%', float: 'left', height: '40px', paddingTop: '10px', paddingLeft: '10px', fontSize: '14px' }}>Select QR Code Profile</span>
                    <span style={{ width: '60%', float: 'right', borderLeft: '1px solid #d2d6de', height: '40px', paddingTop: '10px', paddingLeft: '10px', fontSize: '14px' }}>QR Code Profile details</span>
                </div>

                <div className="dx-field" style={{ paddingTop: '45px', paddingLeft: '10px' }}>QR Code Profiles</div>

                <div className="option" style={{ paddingLeft: '10px' }}>
                    <DataGrid
                        height={550} width={800}
                        dataSource={this.state.qrprofiles}
                        showRowLines={true}

                        showBorders={true}
                        keyExpr="id"




                    >
                        <Column dataField="name" />
                        <Column dataField="defaultProfile" />
                        <Column dataField="useCustomQuery" />
                        <Column dataField="dataQuery" />

                        <Column type="buttons" caption="Generate QR Code"  >
                            <Button hint="Generate QR Code" text="Generate QR Code" visible={true} disabled={false}
                                onClick={this.onClickButton} />
                        </Column>



                        <Scrolling mode="virtual" />



                    </DataGrid>
                    <div><span onClick={this.onClickButton}>eola pame re
                    </span></div>
                </div>

            </div>
        );
    }
}

  
const mapStateToProps = state => {
    return {
        usedataState: state.userData,
        taskIdState: state.taskDataId,
        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,
        roledataId: state.roleDataId,
        taskNameState: state.taskDataName,
        folderIdState: state.folderDataId,
        folderNameState: state.folderDataName,
        contextSelectionIdState: state.contextIdSelection,
        directoryIdState: state.directoryDataId,
        directoryNameState: state.directoryDataName,
        currentObjectIdState: state.currentObjectID,
        reduxState: state,
        contextConfig: state.currentContextConfiguration,
        actionMessage: state.currentActionmessage,
        themeState: state.currentThemeName,
        footerState: state.currFooterState,
        dashboardlist: state.currDashboardlistState,
        taskNotifications: state.currTaskNotificationState,
        folderNotifications: state.currFolderNotificationState,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        folderExpandCollapse: state.currFolderExpandCollapse,
        dashboardlist: state.currDashboardlistState,
        rootContextState: state.rootContext,
        rootSelectedState: state.rootSelected,
        multirootContext: state.currentActionmultiroot,
        windowpopupState: state.windowpopup,
        actionState: state.taaction,


    }
};
const mapDispatchToProps = dispatch => {
    return {
     

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SelectQRCodeProfile);
//export default SelectQRCodeProfile;


// WEBPACK FOOTER //
// ./src/components/WindowPopUp/SelectQRCodeProfile.js